import { RootState } from "../Store";

export const SELECT_ROUTINIG = (state: RootState) => state.routingSlice;
